module.exports = {
  "name": "Meetings App",
  "short_name": "Meetings",
  "description": "Meetings and recordings for the community",
  "start_url": "/",
  "display": "standalone",
  "background_color": "#fff7e0",
  "theme_color": "#ffae00",
  "orientation": "portrait-primary",
  "icons": [
    {
      "src": "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 192 192'%3E%3Crect fill='%23ffae00' width='192' height='192' rx='40'/%3E%3Ctext x='96' y='118' font-size='80' text-anchor='middle' fill='%23fff7e0' font-family='sans-serif' font-weight='bold'%3EM%3C/text%3E%3C/svg%3E",
      "sizes": "192x192",
      "type": "image/svg+xml",
      "purpose": "any"
    }
  ]
}
;